module.exports = __webpack_public_path__ + "img/5_58.813db440.png";